import { builder } from 'common/js/configs';

export const commonArrowBtn = {
  useArrowBtn: builder.boolean('use_animated_arrow', {
    defaultValue: true,
    d:''
  })
};
